import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import NavItem from "../components/NavItem";
import { userSelectors } from "../selectors";
import Logout from "./Logout";

const Header = ({ loggedIn, canViewAuditLogs }) => (
  <header id="navigation" className="p-navigation">
    <div className="p-navigation__banner">
      <div className="p-navigation__logo">
        <h3 className="p-navigation__logo-text">RBAC</h3>
      </div>
      <a href="#navigation" className="p-navigation__toggle--open" title="menu">
        Menu
      </a>
      <a
        href="#navigation-closed"
        className="p-navigation__toggle--close"
        title="close menu"
      >
        Close menu
      </a>
    </div>
    {loggedIn && (
      <nav className="p-navigation__nav">
        <ul className="p-navigation__links" role="menu">
          <NavItem to="/policies" exact>
            Policies
          </NavItem>
          <NavItem to="/listview" exact>
            List View
          </NavItem>
        </ul>
        <ul className="p-navigation__links--right" role="menu">
          {canViewAuditLogs && (
            <NavItem to="/logs" exact>
              Logs
            </NavItem>
          )}
          <NavItem to="/settings" exact>
            Settings
          </NavItem>
          <Logout />
        </ul>
      </nav>
    )}
  </header>
);

Header.displayName = "Header";

Header.propTypes = {
  canViewAuditLogs: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  canViewAuditLogs: userSelectors.canViewAuditLogs(state),
  loggedIn: state.user.loggedIn
});

export default withRouter(connect(mapStateToProps)(Header));
